import { ChangeEvent, memo } from 'react';

import { clsx } from 'clsx';

import cls from './Switch.module.scss';

type SwitchProps = {
  value: boolean;
  onChange: (value: boolean) => void;
  className?: string;
  testId?: string;
};

export const Switch = memo(({ value, className, onChange, testId }: SwitchProps) => {
  const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  return (
    <label className={clsx(cls.wrap, className, { [cls.active]: value })}>
      <span className={cls.circle} />
      <input
        data-testid={testId}
        onChange={onChangeHandler}
        checked={value}
        type="checkbox"
        className={cls.input}
      />
    </label>
  );
});
